import React from 'react'
import { useTranslation } from 'react-i18next'
import { Avatar, Box, Button, Card } from '@node-space/ui-components'

export interface RewardsAssetProps {
  currency: string
  apyRate: string
  availableAmount: string
  onSeeDetails?: () => void
}

export const RewardsAsset = ({
  currency,
  apyRate,
  availableAmount,
  onSeeDetails,
}: RewardsAssetProps) => {
  const { t } = useTranslation()

  return (
    <Card variant="static" emphasis full>
      <Box flexCol gapY={24} paddingY={8}>
        <Box flex align="center" gap={8}>
          <Avatar name={currency} />
          <h2 className="text-h2 text-foreground-prominent">{currency}</h2>
        </Box>

        <Box flex align="start" justify="between" width="full" gap={16}>
          <Box flexCol>
            <p className="text-h2 text-foreground-prominent">{apyRate}</p>
            <p className="text-body-regular text-foreground-subdued">{t('rewards.rewardsRate')}</p>
          </Box>

          <Box flexCol>
            <p className="text-body-regular text-foreground-subdued">
              {t('rewards.availableToAllocate')}
            </p>
            <p className="text-h2 text-foreground-prominent">{availableAmount}</p>
          </Box>
        </Box>

        {onSeeDetails && (
          <Button variant="ghost" onClick={onSeeDetails} className="w-full">
            {t('rewards.seeDetails')}
          </Button>
        )}
      </Box>
    </Card>
  )
}
